import { DeprecationsPlugin, PromisesPlugin, TemplateParamsPlugin, AliasSortingPlugin } from "/codebuild/output/src1035372185/src/actions-runner/_work/onenews/onenews/web-services/node_modules/.pnpm/@unhead+vue@2.0.5_vue@3.5.13_typescript@5.8.2_/node_modules/@unhead/vue/dist/plugins.mjs";
export default {
  disableDefaults: true,
  disableCapoSorting: false,
  plugins: [DeprecationsPlugin, PromisesPlugin, TemplateParamsPlugin, AliasSortingPlugin],
}